import React from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const ContactInfoSidebar = () => {
  const contactMethods = [
    {
      icon: "Phone",
      label: "Call Us",
      value: "+385 95 904 8811",
      href: "tel:+385959048811",
      description: "Primary contact number",
      color: "text-primary",
    },
    {
      icon: "Phone",
      label: "Alternative Phone",
      value: "+385 95 905 2151",
      href: "tel:+385959052151",
      description: "Available if primary is busy",
      color: "text-primary",
    },

    {
      icon: "Mail",
      label: "Email Us",
      value: "sonja.drglin@gmail.com",
      href: "mailto:sonja.drglin@gmail.com",
      color: "text-primary",
    },
    {
      icon: "MessageCircle",
      label: "WhatsApp",
      value: "+385 95 904 8811",
      href: "https://wa.me/385959048811",
      description: "Quick messaging support",
      color: "text-primary",
    },
    {
      icon: "MapPin",
      label: "Visit Us",
      value: "Rapska ul. 10, 51500, Krk, Croatia",
      href: "https://maps.app.goo.gl/RzYGGzyMvRd784Cq7",
      description: "5-minute walk from city center",
      color: "text-primary",
    },
  ];

  const businessHours = [
    { day: "Monday - Friday", hours: "9:00 AM - 8:00 PM" },
    { day: "Saturday", hours: "10:00 AM - 6:00 PM" },
    { day: "Sunday", hours: "10:00 AM - 4:00 PM" },
  ];

  return (
    <div className="space-y-6">
      {/* Contact Methods */}
      <div className="bg-card rounded-xl p-6 border shadow-subtle">
        <h3 className="font-heading text-xl font-semibold text-foreground mb-6">
          Get in Touch
        </h3>

        <div className="space-y-4">
          {contactMethods?.map((method, index) => (
            <a
              key={index}
              href={method?.href}
              target={method?.href?.startsWith("http") ? "_blank" : undefined}
              rel={
                method?.href?.startsWith("http")
                  ? "noopener noreferrer"
                  : undefined
              }
              className="flex items-start space-x-4 p-3 rounded-lg hover:bg-muted/50 transition-smooth group"
            >
              <div className="flex-shrink-0">
                <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center group-hover:bg-primary/20 transition-smooth">
                  <Icon
                    name={method?.icon}
                    size={18}
                    className={method?.color}
                  />
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-medium text-foreground text-sm mb-1">
                  {method?.label}
                </h4>
                <p className="text-sm text-foreground break-words">
                  {method?.value}
                </p>
                <p className="text-xs text-muted-foreground mt-1">
                  {method?.description}
                </p>
              </div>
              <Icon
                name="ExternalLink"
                size={14}
                className="text-muted-foreground opacity-0 group-hover:opacity-100 transition-smooth"
              />
            </a>
          ))}
        </div>
      </div>

      {/* Map */}
      <div className="bg-card rounded-xl p-6 border shadow-subtle">
        <h3 className="font-heading text-xl font-semibold text-foreground mb-6">
          Our Location
        </h3>

        <div className="aspect-w-16 aspect-h-10 mb-4">
          <div className="w-full h-48 bg-muted rounded-lg relative overflow-hidden">
            <iframe
              src={`https://www.google.com/maps?q=${encodeURIComponent(
                "Rapska 10, 51500 Krk, Croatia"
              )}&output=embed`}
              width="100%"
              height="220"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>

        <Button
          variant="outline"
          size="sm"
          fullWidth
          iconName="Navigation"
          iconPosition="left"
          onClick={() =>
            window?.open("https://maps.app.goo.gl/RzYGGzyMvRd784Cq7", "_blank")
          }
        >
          Get Directions
        </Button>
      </div>

      {/* Quick Actions */}
      <div className="bg-accent/10 border border-accent/20 rounded-xl p-6">
        <div className="flex items-center space-x-3 mb-4">
          <Icon name="Zap" size={20} className="text-accent" />
          <h3 className="font-medium text-foreground">
            Need Immediate Assistance?
          </h3>
        </div>

        <p className="text-sm text-muted-foreground mb-4">
          For urgent booking matters or immediate support, call us directly or
          send a WhatsApp message.
        </p>

        <div className="grid grid-cols-2 gap-3">
          <Button
            variant="outline"
            size="sm"
            iconName="Phone"
            iconPosition="left"
            onClick={() => window?.location?.assign("tel:+385959048811")}
            className="text-xs"
          >
            Call Now
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="MessageCircle"
            iconPosition="left"
            onClick={() => window?.open("https://wa.me/385959048811", "_blank")}
            className="text-xs"
          >
            WhatsApp
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ContactInfoSidebar;
